
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/claims-compliance/claims-bulletin",
      function () {
        return require("private-next-pages/compliance/claims-compliance/claims-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/claims-compliance/claims-bulletin"])
      });
    }
  